export const EVENTS = {
  JL_EVENTS_ADD_TO_BASKET_SUCCESS: "jl-events.browser.addToBasketSuccess",
  JL_EVENTS_ADD_TO_BASKET_ERROR: "jl-events.browser.addToBasketError",
  JL_EVENTS_ADD_TO_BASKET_CLICK: "jl-events.browser.addToBasketClick",
  JL_EVENTS_BASKET_QUANTITY_UPDATED: "jl-events.browser.basketQuantityUpdated",
  JL_EVENTS_EMAILME_CLOSE: "jl-events.browser.closeEmailMeModal",
};
